<ng-container
  *ngIf="{
    isActive: navigationActive$ | async,
    user: user$ | async
  } as navigation"
>
  <div class="navigation-burger">
    <div
      (click)="toggleNavigation()"
      (keydown)="toggleNavigation()"
      [ngClass]="{ active: navigation.isActive }"
      class="navigation-burger__button"
    >
      <span class="navigation-burger__button__layer"></span>
      <span class="navigation-burger__button__layer"></span>
      <span class="navigation-burger__button__layer"></span>
    </div>
  </div>
  <div [ngClass]="{ active: navigation.isActive }" class="navigation">
    <nav class="navigation__container">
      <div
        *ngIf="navigation.user && navigation.user.name"
        class="navigation__user"
      >
        <div class="navigation__user__icon">
          <ui-icon icon="person_outline" [filled]="true"></ui-icon>
        </div>
        <div class="navigation__user__details">
          <h4 class="navigation__user__details__name">
            {{ navigation.user.name }}
          </h4>
        </div>
      </div>
      <div class="navigation__items">
        <ul class="navigation__items__list">
          <li>
            <a
              (click)="closeNavigation()"
              class="navigation__items__link"
              routerLink="/dashboard"
              routerLinkActive="active"
            >
              <div class="navigation__items__link__icon">
                <ui-icon icon="home"></ui-icon>
              </div>
              <div class="navigation__items__link__text">Dashboard</div>
            </a>
          </li>
          <li>
            <a
              (click)="closeNavigation()"
              class="navigation__items__link"
              routerLink="/compliance"
              routerLinkActive="active"
            >
              <div class="navigation__items__link__icon">
                <ui-icon icon="assignment"></ui-icon>
              </div>
              <div class="navigation__items__link__text">Compliance</div>
            </a>
          </li>
          <li>
            <a
              (click)="closeNavigation()"
              class="navigation__items__link"
              routerLink="/profile"
              routerLinkActive="active"
            >
              <div class="navigation__items__link__icon">
                <ui-icon icon="person"></ui-icon>
              </div>
              <div class="navigation__items__link__text">Profile</div>
            </a>
          </li>
          <li>
            <a
              (click)="closeNavigation()"
              class="navigation__items__link"
              routerLink="/training"
              routerLinkActive="active"
            >
              <div class="navigation__items__link__icon">
                <ui-icon icon="menu_book"></ui-icon>
              </div>
              <div class="navigation__items__link__text">Training</div>
            </a>
          </li>
          <li>
            <a
              (click)="closeNavigation()"
              class="navigation__items__link"
              routerLink="/resources"
              routerLinkActive="active"
            >
              <div class="navigation__items__link__icon">
                <ui-icon icon="interests"></ui-icon>
              </div>
              <div class="navigation__items__link__text">Resources</div>
            </a>
          </li>
          <li
            *ngIf="
              navigation?.user?.division &&
              navigation?.user?.division !== Division.roi &&
              navigation?.user?.hasNmcSkill
            "
          >
            <a
              (click)="closeNavigation()"
              class="navigation__items__link"
              routerLink="/revalidation"
              routerLinkActive="active"
            >
              <div class="navigation__items__link__icon">
                <ui-icon icon="verified"></ui-icon>
              </div>
              <div class="navigation__items__link__text">Revalidation</div>
            </a>
          </li>
          <div class="navigation__items__splitter"></div>
          <li>
            <a
              (click)="closeNavigation()"
              class="navigation__items__link"
              routerLink="/help-and-support"
              routerLinkActive="active"
            >
              <div class="navigation__items__link__icon">
                <ui-icon icon="quiz"></ui-icon>
              </div>
              <div class="navigation__items__link__text">Help and support</div>
            </a>
          </li>
          <li>
            <a
              (click)="onQuickNurseClick($event)"
              (keydown)="onQuickNurseClick($event)"
              class="navigation__items__link"
            >
              <div class="navigation__items__link__icon">
                <ui-icon icon="medical_services"></ui-icon>
              </div>
              <div
                class="navigation__items__link__text navigation__items__link__text--quick-nurse"
              >
                <div>Quick Nurse</div>
                <div>
                  <ui-icon icon="open_in_new"></ui-icon>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a
              (click)="logOut($event)"
              (keydown)="logOut($event)"
              class="navigation__items__link"
              routerLinkActive="active"
            >
              <div class="navigation__items__link__icon">
                <ui-icon icon="logout"></ui-icon>
              </div>
              <div class="navigation__items__link__text">Log Out</div>
            </a>
          </li>
        </ul>
      </div>
      <div class="navigation__policies">
        <a
          [href]="
            company === Company.tns
              ? 'https://thornbury-nursing.com/privacy-policy/'
              : 'https://nursingguild.com/privacy-policy/'
          "
          class="navigation__items__link navigation__policies__link"
          target="_blank"
        >
          <span
            class="navigation__items__link__text navigation__policies__link__text"
            >Privacy policy</span
          >
          <span class="navigation__items__link__icon small">
            <ui-icon icon="open_in_new"></ui-icon>
          </span>
        </a>
      </div>
      <div class="navigation__support"></div>
    </nav>
  </div>
</ng-container>
